import { useStaticQuery, graphql } from 'gatsby'

export const useMenuQuery = () => {
  const data = useStaticQuery(
    graphql`
      query WpMenuQuery {
        primaryMenu: wpMenu(id: { eq: "dGVybTo2ODY=" }) {
          id
          name
          menuItems {
            nodes {
              cssClasses
              description
              label
              id
              parentId
              url
              target
              path
              childItems {
                nodes {
                  id
                  cssClasses
                  parentId
                  path
                  label
                  description
                  acfMenuItem {
                    menuitemBackgroundClass
                    menuitemIsFeatured
                    featuredImage {
                      sourceUrl
                    }
                  }
                  acfSocialicons {
                    hasSocialIcons
                    socialIcons {
                      socialIconLink
                      socialIconCode
                    }
                  }
                }
              }
            }
          }
        }
        growth: wpMenuItem(id: { eq: "cG9zdDo1Mzg1" }) {
          label
          url
          childItems {
            nodes {
              cssClasses
              description
              id
              label
              url
              target
              path
              acfMenuItem {
                menuitemIsFeatured
                menuitemBackgroundClass
                featuredImage {
                  altText
                  sourceUrl
                }
              }
            }
          }
        }
        education: wpMenuItem(id: { eq: "cG9zdDo1MTA2" }) {
          label
          url
          childItems {
            nodes {
              cssClasses
              description
              id
              label
              url
              target
              path
              acfMenuItem {
                menuitemIsFeatured
                menuitemBackgroundClass
                featuredImage {
                  altText
                  sourceUrl
                }
              }
            }
          }
        }
        about: wpMenuItem(id: { eq: "cG9zdDo1NDEz" }) {
          label
          url
          childItems {
            nodes {
              cssClasses
              description
              id
              label
              url
              target
              path
              acfMenuItem {
                menuitemIsFeatured
                menuitemBackgroundClass
                featuredImage {
                  altText
                  sourceUrl
                }
              }
              acfSocialicons {
                hasSocialIcons
                socialIcons {
                  socialIconLink
                  socialIconCode
                }
              }
            }
          }
        }
        secondaryMenu: wpMenu(id: { eq: "dGVybTo2ODc=" }) {
          name
          menuItems {
            nodes {
              cssClasses
              description
              label
              parentId
              url
              target
              path
            }
          }
        }
      }
    `
  )
  return data
}
